<template>
  <div id="state">
    <vue-json-pretty
      :data="state"
      collapsed-on-click-brackets
      :showLength="true"
      :deep="2"
    >
    </vue-json-pretty>
  </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "Debug",
  components: {
    VueJsonPretty
  },
  data() {
    return {};
  },
  computed: {
    state() {
      return this.$store.state.botState;
    }
  }
};
</script>
